<template>
  <div class="work-unit target" @click="methods.brandName()">
		<div class="work-unit__num" v-if="item.pid">
			<div class="t-h--11">
				<span class="t--fak"><span class="t--ft">(</span>N°{{ item.pid }}<span class="t--ft">)</span></span>
			</div>
		</div>
		<component :is="`button`" class="l-mdl--8 work-unit__lnk" :href="`/work/${item.url}`" :router-to="`/work/${item.url}`">
			<div class="work-unit__thumb">
				<Picture v-if="!lazy" :hover="true" :src="item.thumbnail" type="thumb" />
				<Picture v-else :hover="true" :src="item.thumbnail" :lazy="true" :thumbnailRatio="item.thumbnailRatio" :placeholderColor="'#' + item.color[1]" type="thumb"/>
				<!-- <Picture :hover="true" :parallax="false" :src="item.thumbnail" ratio="96x120"/> -->
			</div>
			<template v-if="!noInfo">
				<BreakLine
					class="l-mdl--8 work-unit__info"
					:class="{'l-mdl--4s': layoutType == 'archive'}"
					:brand="item.brand"
					:type="item.type"
					:year="data.year"
					:no-border="notBorder"
					:layoutType="layoutType"
				/>
			</template>
		</component>
		<!-- <a class="l-mdl--8 work-unit__lnk" :href="`/work/${item.id}`" :router-to="`/work/${item.id}`">
			<div class="work-unit__thumb">
				<Picture :hover="true" :src="item.thumbnail" ratio="96x120"/>
			</div>
			<template v-if="!noInfo">
				<BreakLine
				:brand="item.brand"
				:type="item.type"
				:year="data.year"
				:class="['work-unit__info']"
				:no-border="notBorder"
			/>
			</template>
		</a> -->
	</div>
</template>

<script>
import * as _ from "fxjs";
import { reactive, computed, useStore } from "@/helper/vue.js";
import Picture from "@/parts/picture/PictureView.vue";
import BreakLine from "@/parts/text/breakLine.vue";
export default {
	components:{
		Picture,
		BreakLine
	},
	props: {
		layoutType: {
			type: String,
			default: ""
		},
		lazy: {
			type: Boolean,
			default: false
		},
		item: Object,
		linkType: {
			type: String,
			default: "anchor"
		},
		noInfo: {
			type: Boolean,
			default: false
		},
		notBorder:{
			type: Boolean,
			default: false
		},

		txtEffect: {
			type: Boolean,
			default: false
		}
	},

	setup(props) {
		const { get, commit } = useStore();
		const { brand, color, type, kvLayout, year } = props.item;
		const data = reactive({
			type: computed(() => get["from"](`project.project.modules.0.layout`)),
			year:computed(() =>  {
				let yearTextChange  = String(year)
				let changed = yearTextChange.split('')
				changed.splice(1,1,"k")
				let total = changed.join('')
				return  total
			})

		});
		const methods = {
			brandName:() => {
        commit('set', { sel: `nameUnit`, to: brand })
				commit('set', { sel: `colorUnit`, to: color })
				commit('set', { sel: `typeUnit`, to: type})
				commit('set', { sel: `isWorkUnit`, to: true})
				commit('set', { sel: `kvTypeUnit`, to: kvLayout})
      },
		}

		return {
			self,
			data,
			methods
		}
	}

}
</script>

<style scoped lang="scss">
.work-unit {
	&__thumb {
		position: relative;
		z-index: 30;
		.c-drag__item & {
			background-color: #F2ECE3;
		}
	}
	.g-col--3 & {
		&__num + .work-unit__thumb {
			margin-top: 4em;
		}
		&__info {
			margin-top: 4em;
		}
	}
	&__lnk {
		display: inline-block;;
		width: 100%;
		text-align: left;
	}
}
</style>